import React from 'react';
import { Navigate } from 'react-router-dom';

import { USER_TYPES } from '../../constants';
import { TPage, TRouteComponent } from '../../types';

const RouteComponent: Component<
  { page: TPage } & Omit<TRouteComponent, 'page404Route' | 'LayoutComponent'>
> = ({
  page,
  children,
  unAuthorizedRoute,
  homePageRoute,
  isAuthFetched,
  isAuthenticated,
  LoaderComponent
}) => {
  const { pageConfig } = page;
  const { userGroup, backLink } = pageConfig || {};

  if (!isAuthFetched) {
    return <LoaderComponent />;
  }

  if (userGroup === USER_TYPES.USER && isAuthFetched && !isAuthenticated) {
    return (
      <Navigate
        to={`${unAuthorizedRoute}?redirectUrl=${
          backLink || `${location.pathname}${location.search}`
        }`}
      />
    );
  }

  if (userGroup === USER_TYPES.GUEST && isAuthFetched && isAuthenticated) {
    return <Navigate to={homePageRoute} />;
  }

  return <>{children}</>;
};

export default RouteComponent;
